import React from 'react';
import styled from 'styled-components';

const SearchParamsLabel = (props) => {
  const { label } = props;
  return <StyledLabel>{label}</StyledLabel>;
};

const StyledLabel = styled.span`
  color: #007aff;
`;

export default SearchParamsLabel;
